import React, {PropTypes} from 'react';
import {Col, ControlLabel, FormControl, HelpBlock} from '@sketchpixy/rubix';
import InputValidationType from '../../../constants/InputValidationType';
import {StyledFormGroup} from '../FromStyle';

const textInputForm = (props) => (
    <StyledFormGroup validationState={props.validationState.validationName}>
      <Col xs={3} componentClass={ControlLabel}>
        {props.label}
      </Col>
      <Col xs={3}>
        <FormControl
            type={props.type}
            placeholder={props.placeholder}
            value={props.value}
            onChange={props.valueChangeHandler}
        />
        {
          props.help ? (
              <HelpBlock>{props.help}</HelpBlock>
          ) : null
        }
      </Col>
    </StyledFormGroup>
);

textInputForm.propTypes = {
  validationState: PropTypes.instanceOf(InputValidationType).isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  valueChangeHandler: PropTypes.func.isRequired,
  help: PropTypes.string,
};

export default textInputForm;



// WEBPACK FOOTER //
// ./src/routes/payment/TextInputForm/TextInputForm.js